import IconChevronRight from '../../../assets/arrow-right.svg?react';
import { SimpleReactComponentProps } from '../../../types/components';

type IconDirection = 'right' | 'left' | 'up' | 'down';

interface IconChevronProps extends SimpleReactComponentProps {
	direction?: IconDirection;
}

const svgClasses = 'fill-none stroke-black h-3 w-3';

export const IconChevron = ({
	classOverrides,
	direction = 'right',
}: IconChevronProps) => {
	const getTransformationForDirection = (direction: IconDirection) => {
		switch (direction) {
			case 'down':
				return 'rotate(90)';
			case 'up':
				return 'rotate(270)';
			case 'left':
				return 'rotate(180)';
			default:
				return '';
		}
	};

	return (
		<IconChevronRight
			className={classOverrides || svgClasses}
			transform={getTransformationForDirection(direction)}
		/>
	);
};
